import Button from '../button/button'

import { VscChevronRight, VscChromeClose, VscEllipsis } from 'react-icons/vsc'
import { useLocation, useNavigate } from 'react-router-dom'
import { GiTripleShells } from 'react-icons/gi'

import './tapbar.scss'

type TapbarPorps = {
  openTabs: Array<{ path: string, title: string  }>
  setOpenTabs: (value: Array<{ path: string, title: string  }>) => void
}

function Tapbar(props: Readonly<TapbarPorps>) {
  const location = useLocation()
  const navigate = useNavigate();

  const openTab = (path: string) => {
    if(props.openTabs.find(tab => tab.path === path)) {
      navigate(path)
    }
  }

  const closeTab = async(path: string) => {
    const newopenTabs: Array<{ path: string, title: string }> = JSON.parse(JSON.stringify(props.openTabs))
    const index = newopenTabs.findIndex((tab) => tab.path === path)
    newopenTabs.splice(index, 1)
    props.setOpenTabs(newopenTabs)
    if(path === location.pathname) {
      navigate(newopenTabs[0].path)  
    }
  }

  const tap = (index: number, title: string, active: boolean, path: string) => {
    return (
      <div 
        key={index}
        className={`tapBar-tap ${active && 'tapBar-tapActive'}`}
        onClick={(e) => {
          e.stopPropagation()
          openTab(path)
        }}
      >
        <GiTripleShells /> 
        {title}
        <Button
          disabled={props.openTabs.length === 1}
          icon={<VscChromeClose />}
          click={() => {closeTab(path)}}
          size='small'
        />
      </div>
    )
  }
  
  return (
    <div style={{ width: '100%', overflow: 'auto' }}>
      <div className='comp-tapBar'>
        {props.openTabs.map((tab, index) => tap(index, `${tab.title}.tsx`, location.pathname === tab.path, tab.path))}

        <div className='tapBar-right'>
          <Button 
            icon={<VscEllipsis />}
            size='small'
            click={() => {}}
            dropdown={[{ title: 'Close All', onClick: () => { 
              props.setOpenTabs(props.openTabs.filter(tap => tap.path === '/')) 
              navigate('/')
            }}]}
            dropdownPosition='bottomLeft'
          />
        </div>
      </div>

      {props.openTabs.map((tab) => {
        if(location.pathname === tab.path) {
          return (
            <div className='comp-breadcrumbs' key={tab.path + tab.title}>        
              src <VscChevronRight /> pages <VscChevronRight /> {tab.title} <VscChevronRight /> <GiTripleShells  className='hole'/> {tab.title}.tsx
            </div>
          )
        }
        return ''
      })}

    </div>
  )
}

export default Tapbar
